import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {Part} from "../../products/part";
import {SerialNumberResearchService} from "../../services/serial-number-research.service";
import {StringUtils} from "../../utils/string-utils";
import { CurrencyPipe } from "@angular/common";
import {ProductInformation} from "../parts-dialog/product-information";

@Component({
    selector: 'app-individual-part-dialog',
    imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatDialogClose,
    MatButton,
    CurrencyPipe
],
    templateUrl: './individual-part-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './individual-part-dialog.component.css'
})
export class IndividualPartDialogComponent {
  private readonly serialNumberResearchService = inject(SerialNumberResearchService);
  private readonly data = inject(MAT_DIALOG_DATA);


  part: Part;
  readonly productInformation = signal<ProductInformation>(undefined!);
  readonly errorMessage = signal<string>(undefined!);

  constructor() {
    const data = this.data;

    this.part = data.part;
    this.serialNumberResearchService.getProductInformation(this.part.partNumber).subscribe(
      {
        next: (result) => {
          if (result) {
            this.productInformation.set(result);
          }
        }, error: (error) => this.handleError(error)
      }
    );
  }

  private handleError(error: any): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }
}
